// Cookie functions
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var ajaxUrl = '',
    isUserLoggedIn = false;

function checkUserLoginCookie() {
    var user = getCookie("user-login");

    if (user != "") {
        ajaxUrl = './config/iframe-questions-user.json'; // User is Logged and set path for questions for logged user
        isUserLoggedIn = true;
    } else {
        ajaxUrl = './config/iframe-questions-guest.json'; // User is NOT Logged - path for questions for NOT logged user
    }
}

checkUserLoginCookie();

// Initial actions

document.addEventListener('DOMContentLoaded', function () {
    var openChatButton = document.getElementById('button-chat'),
        faqButton = document.getElementById('button-faq');

    checkUserLoginCookie();

    faqButton.onclick = function () {
        if (isUserLoggedIn) {
            window.top.location.pathname = '/faq';
        } else {
            window.top.location.pathname = '/faq-guest';
        }
    };

    if (!isUserLoggedIn) {
        openChatButton.style.display = 'none';
    }

    renderData();
});

var questionsContainer = document.getElementById('container');

// Getting JSON data with Q&A with AJAX 
function renderData() {
  try {
      var request = new XMLHttpRequest();

      request.open('GET', ajaxUrl, true);

      request.onload = function () {
          if (request && request.status >= 200 && request.status < 400) {
              var allQuestions = JSON.parse(request.responseText),
                  checkboxIdCounter = 1;

              // Iterating through the object and dynamically creating elements, filling them with data
              for (var singleQuestionObject of allQuestions) {
                  var singleQuestionContainer = singleQuestionObject.questions;

                  for (var singleQuestion of singleQuestionContainer) {

                      var newNode = document.createElement('div'),
                          questionNode = document.createElement('div');
                      // answerNode = document.createElement('div');

                      // Generating Each Qestion and Answer
                      // var questionCheckbox = document.createElement('input'),
                      var questionLabel = document.createElement('a');

                      // questionCheckbox.type = 'radio';
                      // questionCheckbox.name = 'tabs';
                      // questionCheckbox.id = 'question' + checkboxIdCounter + '-checkbox';
                      // questionCheckbox.className = 'question-checkbox';
                      if (isUserLoggedIn) {
                          questionLabel.href = '//' + window.location.host + '/faq/' + singleQuestionObject.categoryUrl + '/' + singleQuestion.questionUrl;
                      } else {
                          questionLabel.href = '//' + window.location.host + '/faq-guest/' + singleQuestionObject.categoryUrl + '/' + singleQuestion.questionUrl;
                      }
                      questionLabel.htmlFor = 'question' + checkboxIdCounter + '-checkbox';
                      questionLabel.className = 'question-label';
                      questionLabel.innerHTML = singleQuestion.question;
                      questionLabel.target = '_blank';
                      checkboxIdCounter++;

                      // newNode.appendChild(questionCheckbox);
                      newNode.appendChild(questionLabel);

                      // answerNode.className = 'answer';
                      // answerNode.innerHTML = singleQuestion.answer;

                      // newNode.appendChild(answerNode);

                      questionsContainer.appendChild(newNode);

                      
                  }
              }
          } else {
              console.log('Error getting response');
          }
      };

      request.send();
  } catch (error) {
      console.error(error)
  }
}